function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, Object) {
    var h = require("panel").h;
    return {
      value: (h("div", {
        "class": Object.assign({}, {
          'mp-list-item-active': $attr(`active`),
          'mp-list-item-static': $attr(`static`),
          'mp-list-item-disabled': $attr(`disabled`),
        }, {
          'mp-list-item-container': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("slot"));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;